// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductSquare_container__I9rba","image":"ProductSquare_image__BB7iH"};